import { type ReactNode } from 'react';
import { Center, Column , CircularProgress } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { EmbeddedListItem } from './EmbeddedListItem';
import { type IListItemData } from './professionalAdapters';

interface ITabContentProps {
  isLoading: boolean;
  professionals: IListItemData[];
  selectedProfessionals: Set<string>;
  onSelectProfessionals: (ids: string[], forceAdd?: boolean) => void;
  onViewSkills: (pro: IListItemData) => void;
  emptyComponent: ReactNode;
  testId: string;
}

const SCROLL_STYLE = {
  overflowY: 'auto' as const,
  scrollbarWidth: 'thin' as const,
  scrollbarColor: `${colors.neutral[200]} transparent`,
  padding: '0 8px',
};

const LIST_MAX_HEIGHT = 420;

export const TabContent = ({
  isLoading,
  professionals,
  selectedProfessionals,
  onSelectProfessionals,
  onViewSkills,
  emptyComponent,
  testId,
}: ITabContentProps) => {
  if (isLoading) {
    return (
      <Center py={6}>
        <CircularProgress />
      </Center>
    );
  }

  if (professionals.length === 0) {
    return <>{emptyComponent}</>;
  }

  return (
    <Column
      data-testid={testId}
      data-cy={testId}
      style={{ maxHeight: LIST_MAX_HEIGHT, ...SCROLL_STYLE }}
    >
      {professionals.map((pro) => (
        <EmbeddedListItem
          key={pro.id}
          id={pro.id}
          fullName={pro.fullName}
          isFavorite={pro.isFavorite}
          isAvailable={pro.isAvailable}
          isSelected={selectedProfessionals.has(pro.id)}
          profileImage={pro.profileImage}
          rating={pro.rating}
          badges={pro.badges}
          onItemClick={(id) => onSelectProfessionals([id])}
          onViewSkills={() => onViewSkills(pro)}
        />
      ))}
    </Column>
  );
};
